"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Fertilityacupunctureclinical() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = ["ADVANCED CHIROPRACTIC CARE", "CLINICAL ACUPUNCTURE SESSIONS", "PERSONALISED RECOVERY PLANS", "EXPERT MULTIDISCIPLINARY TEAM"];
  return <section data-section-id="5147" id="fertilityacupunctureclinical" className="bg-background text-foreground relative w-full min-h-screen">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen relative">
        {}
        <div aria-hidden="true" className="hidden lg:block absolute top-0 bottom-0 left-1/2 w-px bg-border z-10" />
        {}
        <div aria-hidden="true" className="hidden lg:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
          <div className="size-3 bg-primary" />
        </div>

        {}
        <div ref={leftRef} className={`relative bg-background px-6 py-16 sm:px-12 sm:py-20 lg:px-24 lg:py-24 flex flex-col justify-center transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex items-center gap-3 mb-12 lg:mb-16">
            <span className="font-default text-[11px] tracking-[0.2em] uppercase text-primary">
              — OUR CLINICAL APPROACH
            </span>
          </div>

          {}
          <div className="mb-10">
            <p className="font-default text-[18px] leading-[1.7] text-foreground/90">
              <span className="float-left font-default text-primary text-[8rem] leading-[0.85] pr-4 pt-2 -ml-1">
                B
              </span>
              ODYWERKS is more than a clinic — it is a sanctuary for physical restoration, where 
              evidence-based chiropractic care meets the precision of acupuncture. Within our 
              modern, welcoming spaces in Limassol and Nicosia, we integrate advanced manual 
              therapies with a deep understanding of the human body. Every treatment is 
              meticulously tailored to your unique needs, ensuring that whether you are a 
              local resident or an international visitor, you receive the highest standard 
              of care in Cyprus.
            </p>
          </div>

          {}
          <div className="w-full h-px bg-border mb-8" />

          {}
          <ul className="space-y-4 mb-12">
            {features.map((feature, i) => <li data-index={i} key={i} className="flex items-start gap-3 font-default text-[12px] tracking-[0.15em] uppercase text-foreground/80">
                <span className="text-primary select-none">—</span>
                <span>{feature}</span>
              </li>)}
          </ul>

          {}
          <div>
            <Button variant="outline" size="lg" className="bg-transparent border border-foreground text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary font-default text-[12px] tracking-[0.2em] uppercase px-8 h-12 transition-colors duration-300" onClick={() => window.location.href = "/BookAppointmentPage"}>
              Book Your Visit
              <ArrowRight className="size-4" />
            </Button>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative min-h-[60vh] lg:min-h-screen overflow-hidden transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609985/img/bodywerks_clinic_interior_professional.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609985/img/bodywerks_clinic_interior_professional.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609985/img/bodywerks_clinic_interior_professional.png-wvc-sizes" alt="Modern, clean, and professional interior of Bodywerks clinic in Cyprus" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
          {}
          <div aria-hidden="true" className="absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none" style={{
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.6'/></svg>\")"
        }} />

          {}
          <div className="absolute bottom-6 right-6 sm:bottom-10 sm:right-10 border border-foreground/90 bg-background/60 backdrop-blur-sm px-4 py-3 shadow-lg">
            <span className="font-default text-[10px] tracking-[0.2em] uppercase text-foreground">
              Bodywerks / Clinical Excellence / Cyprus
            </span>
          </div>
        </div>
      </div>
    </section>;
}